import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/Card';
import { formatDistanceToNow } from 'date-fns';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiGift, FiMapPin } = FiIcons;

const LiveActivity = ({ activity = [] }) => {
  // Show top 10 as requested
  const displayActivity = activity.slice(0, 10);

  return (
    <Card className="h-full flex flex-col overflow-hidden">
      <CardHeader className="pb-3 border-b border-surface-100 flex-shrink-0">
        <div className="flex items-center justify-between">
          <CardTitle className="text-xs font-bold text-surface-400 uppercase tracking-widest">Recent Activity</CardTitle>
          <div className="flex items-center space-x-1.5">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
            </span>
            <span className="text-[10px] font-bold text-emerald-600 uppercase">Live</span>
          </div>
        </div>
      </CardHeader>
      <CardContent className="flex-1 overflow-y-auto p-0 custom-scrollbar max-h-[295px]">
        {displayActivity.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full py-10 opacity-40">
            <SafeIcon icon={FiGift} className="w-8 h-8 mb-2" />
            <p className="text-xs">No activity found</p>
          </div>
        ) : (
          <div className="divide-y divide-surface-50">
            {displayActivity.map((item, idx) => (
              <div key={idx} className="p-3.5 hover:bg-surface-50 transition-colors group">
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 rounded-xl bg-indigo-50 flex items-center justify-center flex-shrink-0 group-hover:bg-indigo-100 transition-colors">
                    <SafeIcon icon={FiGift} className="w-4 h-4 text-indigo-600" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-0.5">
                      <p className="text-xs font-bold text-surface-800 truncate">
                        {item.mobile_no ? item.mobile_no.replace(/(\d{2})(\d{4})(\d{4})/, '$1 *** $3') : 'Unknown User'}
                      </p>
                      <span className="text-[9px] text-surface-400 font-medium whitespace-nowrap ml-2">
                        {item.updated_at ? formatDistanceToNow(new Date(item.updated_at), { addSuffix: true }) : 'now'}
                      </span>
                    </div>
                    <div className="flex items-center justify-between mt-1">
                      <div className="flex items-center space-x-1 text-[10px] text-surface-500">
                        <SafeIcon icon={FiMapPin} className="w-3 h-3 text-surface-400" />
                        <span className="truncate max-w-[80px]">{item.city}</span>
                      </div>
                      <span className="text-[10px] font-bold text-indigo-600 uppercase tracking-tight">
                        {item.selected_gift}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default LiveActivity;